import { readSnapshot, SNAPSHOT_KEY, type ShopSnapshot } from "./shop-view";

/** The snapshot saved for this profile a moment ago, or null -- a private window reads none. */
export function loadSnapshot(slug: string): ShopSnapshot | null {
  try {
    return readSnapshot(window.sessionStorage.getItem(SNAPSHOT_KEY), slug, Date.now());
  } catch {
    return null;
  }
}

/** Where the visitor was, saved on tapping a service or a card. */
export function saveSnapshot(snapshot: ShopSnapshot): void {
  try {
    window.sessionStorage.setItem(SNAPSHOT_KEY, JSON.stringify(snapshot));
  } catch {
    // A private window: «atrás» starts at the top, nothing worse.
  }
}
